import { CASE_DETAIL_KEY, LINK_CODE_KEY, RESUME_CASE_KEY } from '../../utils/constants';
import { getQueryStringValueByName } from '../../utils';
import { selectors } from '../../infrastructure/config';
import groupBy from 'lodash/groupBy';
import get from 'lodash/get';

const SOLE_TRADER = 'sole trader';
export const getAddress = state => {
  const customerAddress =
    state.cases.get('personalAddress') && state.cases.get('personalAddress').toJS();
  if (customerAddress) {
    const houseNo = customerAddress.hasOwnProperty('house_number') && customerAddress.house_number;
    const addressPrefix =
      customerAddress.hasOwnProperty('address_prefix') && customerAddress.address_prefix;
    const street = customerAddress.hasOwnProperty('street') && customerAddress.street;
    const city = customerAddress.hasOwnProperty('city') && customerAddress.city;
    const postcode = customerAddress.hasOwnProperty('postal_code') && customerAddress.postal_code;

    return `${houseNo} ${addressPrefix} ${street},${city} ${postcode}`;
  }
  return '';
};

export const getUsername = state => {
  let caseDetail = state.cases ? state.cases.get(CASE_DETAIL_KEY) : '';
  caseDetail = caseDetail ? caseDetail.toJS() : '';
  const userDetails = caseDetail && caseDetail.applicant && caseDetail.applicant.user_details;
  return userDetails.username;
};

export const business_uuid = state => state.cases.get('business_uuid');

export const getJointLinkCode = state => {
  let caseDetail = state.cases ? state.cases.get(CASE_DETAIL_KEY) : '';
  caseDetail = caseDetail ? caseDetail.toJS() : '';
  return caseDetail && caseDetail.applicant && caseDetail.applicant.joint_link_code
    ? caseDetail.applicant.joint_link_code
    : '';
};

export const isSoleTrader = state => {
  let caseDetail = state.cases ? state.cases.get(CASE_DETAIL_KEY) : '';
  caseDetail = caseDetail ? caseDetail.toJS() : '';
  return caseDetail && caseDetail.product && caseDetail.product.variant
    ? caseDetail.product.variant.toLowerCase() === SOLE_TRADER
    : false;
};

export const getName = state => {
  let caseDetail = state.cases.get(CASE_DETAIL_KEY);
  caseDetail = caseDetail ? caseDetail.toJS() : '';
  return caseDetail &&
    caseDetail.applicant &&
    caseDetail.applicant.personal_details &&
    caseDetail.applicant.personal_details.name
    ? `${caseDetail.applicant.personal_details.name.title} ${
        caseDetail.applicant.personal_details.name.first_name
      } 
    ${caseDetail.applicant.personal_details.name.middle_name &&
      caseDetail.applicant.personal_details.name.middle_name} ${
        caseDetail.applicant.personal_details.name.last_name
      }`
    : '';
};

export const getCaseType = state => {
  const caseDetail = state.cases ? state.cases.toJS() : '';
  return caseDetail && caseDetail.caseData && caseDetail.caseData.case_subtype
    ? caseDetail.caseData.case_subtype
    : '';
};

export const getVariant = state => {
  let caseDetail = state.cases ? state.cases.get(CASE_DETAIL_KEY) : '';
  caseDetail = caseDetail ? caseDetail.toJS() : '';
  return caseDetail && caseDetail.product && caseDetail.product.variant
    ? caseDetail.product.variant
    : '';
};

export const getPersonalCustomerId = state => {
  let caseDetail = state.cases ? state.cases.get(CASE_DETAIL_KEY) : '';
  caseDetail = caseDetail ? caseDetail.toJS() : '';
  return caseDetail && caseDetail.customer_id && caseDetail.customer_id.personal
    ? caseDetail.customer_id.personal
    : '';
};

export const getBusinessId = state => {
  let caseDetail = state.cases ? state.cases.get(CASE_DETAIL_KEY) : '';
  caseDetail = caseDetail ? caseDetail.toJS() : '';
  return caseDetail && caseDetail.customer_id && caseDetail.customer_id.business
    ? caseDetail.customer_id.business
    : '';
};

export const linkCodeAvailable = state => {
  const linkCodeFromHref =
    getQueryStringValueByName(LINK_CODE_KEY) || selectors.getSingleEntry(state, LINK_CODE_KEY);
  return linkCodeFromHref ? linkCodeFromHref : getJointLinkCode(state);
};

export const getProductType = state => {
  let caseDetail = state.cases ? state.cases.get(CASE_DETAIL_KEY) : '';
  caseDetail = caseDetail ? caseDetail.toJS() : '';
  return caseDetail && caseDetail.product && caseDetail.product.type ? caseDetail.product.type : '';
};
const caseTypes = ['CS', 'SA', 'CC', 'BA'];
export const getResumeCases = state => {
  const resumeCases = state.cases ? state.cases.get(RESUME_CASE_KEY) : null;
  if (resumeCases) {
    const casesInformation = groupBy(get(resumeCases.toJS(), 'cases', []), item => {
      const key = item.id.match(/(\w{2})-\d*/);
      return key.length ? key[1] : 'NOGROUPED';
    });
    return caseTypes
      .map(x => casesInformation[x])
      .filter(x => !!x)
      .reduce((prev, curr) => prev.concat(curr), []);
  }
};
